
export const PRIVATO = "privato"
const RIVENDITORE = "rivenditore"
const ALTRO = "altro"
const INSTALLATORE = "installatore"
const ARCHITETTO = "architetto"
const INGEGNERE = "ingegnere"
const COSTRUTTORE = "costruttore"
const GENERAL_CONTRACTOR = "general_contractor"
const AGENTE_VENDITA = "agente_vendita"
export const AZIENDA = "azienda"

export default [
  { value: PRIVATO, label: 'profile_types.privato' },
  { value: RIVENDITORE, label: 'profile_types.rivenditore' },
  { value: INSTALLATORE, label: 'profile_types.installatore' },
  { value: AGENTE_VENDITA, label: 'profile_types.agente_vendita' },
  { value: ARCHITETTO, label: 'profile_types.architetto' },
  { value: INGEGNERE, label: 'profile_types.ingegnere' },
  { value: COSTRUTTORE, label: 'profile_types.costruttore' },
  { value: GENERAL_CONTRACTOR, label: 'profile_types.general_contractor' },
  { value: AZIENDA, label: 'profile_types.azienda' },
  { value: ALTRO, label: 'profile_types.altro' },
]